import axios from 'axios'
// import store from '@/store'
import router from '@/router'
import { Message } from 'view-design'
const baseConfig = {
  baseURL: '/api',
  timeout: 30000,
  // transformRequest: [function (data) {
  //   data = JSON.stringify(data)
  //   return data
  // }],
  // 在传递给 then/catch 前，修改响应数据
  transformResponse: [function (data) {
    if (typeof data === 'string' && data.startsWith('{')) {
      data = JSON.parse(data)
    }
    return data
  }],
  headers: {
    'Content-Type': 'application/json'
  }
}
const httpService = axios.create(baseConfig)
const http = axios.create(baseConfig)

// 请求拦截函数
const requestIterceptor = config => {
  const token = sessionStorage.getItem('token')
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
}
// 请求拦截器
http.interceptors.request.use(requestIterceptor, error => {
  return Promise.reject(error)
})
httpService.interceptors.request.use(requestIterceptor, error => {
  return Promise.reject(error)
})

const errorHandle = (status, message) => {
  switch (status) {
    case 404:
      Message.error('网络请求不存在')
      break
      // 其他错误，直接抛出错误提示
    case 20001:
      Message.error({
        background: true,
        content: message
      })
      // store.commit('removeLoginInfo')
      router.push('/')
      break
    default:
      Message.error({
        background: true,
        content: message
      })
  }
}
// 响应拦截器
httpService.interceptors.response.use(
  response => {
    const data = response.data
    if (response.status === 200 && data.code === 0) {
      return Promise.resolve(data.data)
    } else {
      errorHandle(response.status === 200 ? data.code : response.status, data.msg)
      return Promise.reject(data)
    }
  },
  error => {
    return Promise.reject(error)
  }
)

http.interceptors.response.use(
  response => {
    return Promise.resolve(response)
  }
)
export default httpService
export { http }
